import "./widget_core.js"
import "../../../public/javascripts/backbone/lib/concerns/views/tabindex_helpers.js"
import "../../../public/vendor_modified/sly/dist/sly.js"
var req = require.context('../../../public/javascripts/backbone/apps/coverflow/', true, /\.js$/)
req.keys().forEach(req)
